import React from 'react';
export function LeadTypeOverview() {
  const totalLeads = 101.85;
  const callLeads = 74.33;
  const formLeads = 27.53;
  const callPercentage = callLeads / totalLeads * 100;
  const formPercentage = formLeads / totalLeads * 100;
  return <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-662">
      <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-663">
        Lead Type Overview
      </h3>

      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-664">
        <div className="text-center" data-id="element-665">
          <div className="text-xs text-gray-500 mb-1" data-id="element-666">Total Leads</div>
          <div className="text-2xl font-bold text-gray-900" data-id="element-667">101.85K</div>
        </div>
        <div className="text-center border-l border-gray-200" data-id="element-668">
          <div className="text-xs text-gray-500 mb-1" data-id="element-669">Call Leads</div>
          <div className="text-2xl font-bold text-blue-600" data-id="element-670">74.33K</div>
        </div>
        <div className="text-center border-l border-gray-200" data-id="element-671">
          <div className="text-xs text-gray-500 mb-1" data-id="element-672">Form Leads</div>
          <div className="text-2xl font-bold text-blue-500" data-id="element-673">27.53K</div>
        </div>
      </div>

      {/* Bar visualization */}
      <div data-id="element-674">
        <div className="flex items-center justify-between text-xs text-gray-600 mb-2" data-id="element-675">
          <span data-id="element-676">Call Leads</span>
          <span data-id="element-677">Form Leads</span>
        </div>
        <div className="flex h-12 rounded-lg overflow-hidden" data-id="element-678">
          <div className="bg-[#1e1b4b] flex items-center justify-center text-white text-sm font-medium" style={{
          width: `${callPercentage}%`
        }} data-id="element-679">
            {callPercentage.toFixed(2)}%
          </div>
          <div className="bg-blue-500 flex items-center justify-center text-white text-sm font-medium" style={{
          width: `${formPercentage}%`
        }} data-id="element-680">
            {formPercentage.toFixed(2)}%
          </div>
        </div>
      </div>
    </div>;
}